import { informationConstants } from '../_constants/information.constants';

import { filterCalendarResults } from '../_utils/calendar.utils';
import {
  changePage,
  filterMaximumDrawdown,
  resetMaximumDrawdown,
  changeDrawdownSortingFilters,
  changeNavGraphDate,
  changeSortedDrawdown,
  resetMonthlyReturn,
  filterPriceRange,
  resetPriceRange,
  filterVolatilities,
  resetVolatilities,
  filterReturnExpenseRatio,
  resetReturnExpenseRatio,
  filterMonthlyProfit,
  resetMonthlyProfit,
  filterReturnHistory,
  resetReturnHistory,
  setIsFetching,
  filterDataResult,
  resetDataResult,
  resetDataResultToObject
} from '../_utils/information.utils';

import { filterMonthlyReturn } from '../_utils/investment.utils';
import { sub } from 'date-fns';

const initialState = {
  fundCode: null,
  portfolioInfo: {
    isFetching: false,
    data: {},
    errorMessage: null
  },
  recentTab: '1',
  informationWidget: {
    tabList: [
      /*{
        name: 'ฟีดข่าว',
        icon: 'FeedIcon'
      },*/
      {
        name: 'ข้อมูลกองทุน',
        icon: 'InformationIcon'
      },
      {
        name: 'พอร์ต',
        icon: 'PortfolioIcon'
      },
      {
        name: 'สถิติ',
        icon: 'ChartIcon'
      },
      {
        name: 'กราฟ',
        icon: 'InvestmentStatisticIcon'
      },
      {
        name: 'NAV ย้อนหลัง',
        icon: 'HistoryIcon'
      },
      {
        name: 'ปันผล',
        icon: 'InvestmentIcon'
      }
    ],
    graphMode: [
      {
        name: 'NAV & AUM',
        value: 'NAV'
      },
      {
        name: 'ผลตอบแทน',
        value: 'PERCENT_CHANGE'
      },
      {
        name: 'เงินเข้าออก',
        value: 'FUND_FLOW'
      }
    ],
    selectedBtn: 0,
    fundInformation: {
      isFetching: false,
      data: {},
      errorMessage: null
    },
    navGraph: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
    tradingInformation: {
      isFetching: false,
      data: {},
      errorMessage: null
    },
    averageRating: {
      isFetching: false,
      data: {},
      errorMessage: null
    },
    calendar: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
  },
  fundPortInfo: {
    portInformation: {
      isFetching: false,
      data: {},
      errorMessage: null
    },
    portChartByChartType: {
      isFetching: false,
      data: {},
      errorMessage: null
    }
  },
  statistic: {
    monthlyReturns: [],
    monthlyPofit: null,
    priceRanges: [],
    volatilities: [],
    returnExpenseRatio: null,
    returnHistory: null,
    weeklyRanking: {
      isFetching: false,
      data: {},
      errorMessage: null
    },
    maximumDrawdownList: [],
    drawdownListByDate: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
    navGraphDateRange: {
      startDate: (sub(new Date(), {years: 1})).toJSON(),
      endDate: (new Date()).toJSON()
    },
    drawdownNavGraph: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
    currentDrawdownSortingFilters: 'sortedByPercentage',
    drawdownSortingFilters: [
      {
        name: 'ตามเวลา',
        value: 'sortedByDate'
      },
      {
        name: '% ติดลบ',
        value: 'sortedByPercentage'
      }
    ]
  },
  graphInfo: {
    graphMode: [
      {
        name: 'NAV & AUM',
        value: 'NAV'
      },
      {
        name: 'ผลตอบแทน',
        value: 'PERCENT_CHANGE'
      },
      {
        name: 'เงินเข้าออก',
        value: 'FUND_FLOW'
      }
    ],
    historicalNavGraph: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
  },
  fundHistoricalNav: {
    currentPage: 1,
    totalPage: null,
    headers: [
      {
        header: 'วันที่',
        sortKey: 'dateTime'
      },
      {
        header: 'NAV',
        sortKey: 'navValue'
      },
      {
        header: 'ราคาขาย',
        sortKey: 'saleValue'
      },
      {
        header: 'ราคาซื้อคืน',
        sortKey: 'buyValue'
      },
      {
        header: 'เปลี่ยนแปลง',
        sortKey: 'changeValue'
      },
      {
        header: '%CHANGE',
        sortKey: 'changePercent'
      },
      {
        header: 'AUM',
        sortKey: 'aumValue'
      }
    ],
    historicalNav: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
  },
  dividend: {
    currentPage: 1,
    totalPage: null,
    headers: [
      {
        header: 'ลำดับ',
        sortKey: 'order'
      },
      {
        header: 'วันปิดสมุดทะเบียน',
        sortKey: 'dividendDate'
      },
      {
        header: 'วันที่จ่ายปันผล',
        sortKey: 'paymentDate'
      },
      {
        header: 'บาท / หน่วย',
        sortKey: 'dividend'
      }
    ],
    dividendGroupByYear: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
    dividendByDateType: {
      isFetching: false,
      data: [],
      errorMessage: null
    },
    descriptions: {
      isFetching: false,
      data: [],
      errorMessage: null
    }
  },
};

const informationReducer = (state = initialState, action) => {
  switch (action.type) {
    case informationConstants.UPDATE_FUND_ID: // Update Fund Code to Fetching All APIs in This reducer
      return {
        ...state,
        fundCode: action.payload
      };
    case informationConstants.UPDATE_RECENT_TAB: // remember recent tab
      return {
        ...state,
        recentTab: action.payload
      };
    case informationConstants.FETCH_FUND_INFO_START: // Fetching Fund InFormation Data 
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          fundInformation: setIsFetching(state.informationWidget.fundInformation)
        }
      };
    case informationConstants.FETCH_FUND_INFO_SUCCESS:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          fundInformation: filterDataResult(state.informationWidget.fundInformation, action.payload)
        }
      };
    case informationConstants.FETCH_FUND_INFO_FAILURE:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          fundInformation: resetDataResultToObject(state.informationWidget.fundInformation)
        }
      };
    case informationConstants.CLEAR_FUND_INFO:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          fundInformation: resetDataResultToObject(state.informationWidget.fundInformation)
        }
      };
    case informationConstants.FETCH_TRADING_INFO_START: // Fetching Fund InFormation Data 
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          tradingInformation: setIsFetching(state.informationWidget.tradingInformation)
        }
      };
    case informationConstants.FETCH_TRADING_INFO_SUCCESS:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          tradingInformation: filterDataResult(state.informationWidget.tradingInformation, action.payload)
        }
      };
    case informationConstants.FETCH_TRADING_INFO_FAILURE:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          tradingInformation: resetDataResultToObject(state.informationWidget.tradingInformation)
        }
      };
    case informationConstants.FETCH_PORTFOLIO_INFO_START: // Fetching Fund InFormation Data 
      return {
        ...state,
        portfolioInfo: {
          ...state.portfolioInfo,
          isFetching: true,
        }
      };
    case informationConstants.FETCH_PORTFOLIO_INFO_SUCCESS:
      return {
        ...state,
        portfolioInfo: {
          ...state.portfolioInfo,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case informationConstants.FETCH_PORTFOLIO_INFO_FAILURE:
      return {
        ...state,
        portfolioInfo: {
          ...state.portfolioInfo,
          isFetching: false,
          data: {},
          errorMessage: action.payload
        }
      };
    case informationConstants.FETCH_FUND_AVERAGE_RATING_START: // Fetching Fund InFormation Data 
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          averageRating: setIsFetching(state.informationWidget.averageRating)
        }
      };
    case informationConstants.FETCH_FUND_AVERAGE_RATING_SUCCESS:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          averageRating: filterDataResult(state.informationWidget.averageRating, action.payload)
        }
      };
    case informationConstants.FETCH_FUND_AVERAGE_RATING_FAILURE:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          averageRating: resetDataResultToObject(state.informationWidget.averageRating)
        }
      };
    case informationConstants.FETCH_CALENDAR_FUND_START:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          calendar: setIsFetching(state.informationWidget.calendar)
        }
      };
    case informationConstants.FETCH_CALENDAR_FUND_SUCCESS:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          calendar: filterCalendarResults(state.informationWidget.calendar, action.payload)
        }
      };
    case informationConstants.FETCH_CALENDAR_FUND_FAILURE:
      return {
        ...state,
        informationWidget: {
          ...state.informationWidget,
          calendar: resetDataResult(state.informationWidget.calendar)
        }
      };
    case informationConstants.FETCH_FUND_PORT_INFO_START:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portInformation: setIsFetching(state.fundPortInfo.portInformation)
        }
      };
    case informationConstants.FETCH_FUND_PORT_INFO_SUCCESS:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portInformation: filterDataResult(state.fundPortInfo.portInformation, action.payload)
        }
      };
    case informationConstants.FETCH_FUND_PORT_INFO_FAILURE:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portInformation: resetDataResultToObject(state.fundPortInfo.portInformation)
        }
      };
    case informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_START:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portChartByChartType: setIsFetching(state.fundPortInfo.portChartByChartType)
        }
      };
    case informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_SUCCESS:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portChartByChartType: filterDataResult(state.fundPortInfo.portChartByChartType, action.payload)
        }
      };
    case informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_FAILURE:
      return {
        ...state,
        fundPortInfo: {
          ...state.fundPortInfo,
          portChartByChartType: resetDataResultToObject(state.fundPortInfo.portChartByChartType)
        }
      };
    case informationConstants.FETCH_HISTORICAL_NAV_START:
      return {
        ...state,
        fundHistoricalNav: {
          ...state.fundHistoricalNav,
          historicalNav: setIsFetching(state.fundHistoricalNav.historicalNav)
        }
      };
    case informationConstants.FETCH_HISTORICAL_NAV_SUCCESS:
      return {
        ...state,
        fundHistoricalNav: {
          ...state.fundHistoricalNav,
          currentPage: action.payload.currentPage,
          totalPage: action.payload.totalPage,
          historicalNav: filterDataResult(state.fundHistoricalNav.historicalNav, action.payload.items)
        }
      };
    case informationConstants.FETCH_HISTORICAL_NAV_FAILURE:
      return {
        ...state,  
        fundHistoricalNav: {
          ...state.fundHistoricalNav,
          currentPage: 1,
          totalPage: 1,
          historicalNav: resetDataResult(state.fundHistoricalNav.historicalNav)
        }
      };
    case informationConstants.FETCH_HISTORICAL_NAV_CHANGE_PAGE:
      return {
        ...state,
        fundHistoricalNav: changePage(state.fundHistoricalNav, action.payload)
      };
    case informationConstants.FETCH_HISTORICAL_NAV_GRAPH_START:
      return {
        ...state,
        graphInfo: {
          ...state.graphInfo,
          historicalNavGraph: setIsFetching(state.graphInfo.historicalNavGraph)
        },
      };
    case informationConstants.FETCH_HISTORICAL_NAV_GRAPH_SUCCESS:
      return {
        ...state,
        graphInfo: {
          ...state.graphInfo,
          historicalNavGraph: filterDataResult(state.graphInfo.historicalNavGraph, action.payload)
        },
      };
    case informationConstants.FETCH_HISTORICAL_NAV_GRAPH_FAILURE:
      return {
        ...state,
        graphInfo: {
          ...state.graphInfo,
          historicalNavGraph: resetDataResult(state.graphInfo.historicalNavGraph)
        },
      };
    case informationConstants.FETCH_WEEKLY_FUND_RANKING_START:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          weeklyRanking: setIsFetching(state.statistic.weeklyRanking)
        }
      };  
    case informationConstants.FETCH_WEEKLY_FUND_RANKING_SUCCESS:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          weeklyRanking: filterDataResult(state.statistic.weeklyRanking, action.payload)
        }
      };
    case informationConstants.FETCH_WEEKLY_FUND_RANKING_FAILURE:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          weeklyRanking: resetDataResultToObject(state.statistic.weeklyRanking, action.payload)
        }
      };
    case informationConstants.FETCH_DRAWDOWN_BY_DATE_START:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownListByDate: setIsFetching(state.statistic.drawdownListByDate)
        }
      };  
    case informationConstants.FETCH_DRAWDOWN_BY_DATE_SUCCESS:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownListByDate: filterDataResult(state.statistic.drawdownListByDate, action.payload)
        }
      };
    case informationConstants.FETCH_DRAWDOWN_BY_DATE_FAILURE:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownListByDate: resetDataResult(state.statistic.drawdownListByDate, action.payload)
        }
      };
    case informationConstants.FETCH_MAXIMUM_DRAWDOWN_START:
      return {
        ...state,
        isFetching: true
      };  
    case informationConstants.FETCH_MAXIMUM_DRAWDOWN_SUCCESS:
      return {
        ...state,
        statistic: filterMaximumDrawdown(state.statistic, action.payload)
      };
    case informationConstants.FETCH_MAXIMUM_DRAWDOWN_FAILURE:
      return {
        ...state,
        statistic: resetMaximumDrawdown(state.statistic),
        errorMessage: action.payload
      };
    case informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_START:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownNavGraph: {
            ...state.statistic.drawdownNavGraph,
            isFetching: true
          }
        }
      };  
    case informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_SUCCESS:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownNavGraph: {
            ...state.statistic.drawdownNavGraph,
            isFetching: false,
            data: action.payload,
            errorMessage: null
          }
        }
      };
    case informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_FAILURE:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          drawdownNavGraph: {
            ...state.statistic.drawdownNavGraph,
            isFetching: false,
            data: [],
            errorMessage: action.payload
          }
        }
      };
    case informationConstants.FETCH_MONTHLY_RETURN_START:
      return {
        ...state,
        statistic: resetMonthlyReturn(state.statistic)
      };  
    case informationConstants.FETCH_MONTHLY_RETURN_SUCCESS:
      return {
        ...state,
        statistic: {
          ...state.statistic,
          monthlyReturns: filterMonthlyReturn(action.payload)
        }
      };
    case informationConstants.FETCH_MONTHLY_RETURN_FAILURE:
      return {
        ...state,
        statistic: resetMonthlyReturn(state.statistic),
        errorMessage: action.payload
      };
    case informationConstants.FETCH_PRICE_RANGE_START:
      return {
        ...state,
        statistic: resetPriceRange(state.statistic)
      };  
    case informationConstants.FETCH_PRICE_RANGE_SUCCESS:
      return {
        ...state,
        statistic: filterPriceRange(state.statistic, action.payload)
      };
    case informationConstants.FETCH_PRICE_RANGE_FAILURE:
      return {
        ...state,
        statistic: resetPriceRange(state.statistic),
        errorMessage: action.payload
      };
    case informationConstants.FETCH_VOLATILITIES_START:
      return {
        ...state,
        statistic: resetVolatilities(state.statistic)
      };  
    case informationConstants.FETCH_VOLATILITIES_SUCCESS:
      return {
        ...state,
        statistic: filterVolatilities(state.statistic, action.payload)
      };
    case informationConstants.FETCH_VOLATILITIES_FAILURE:
      return {
        ...state,
        statistic: resetVolatilities(state.statistic),
      };
    case informationConstants.FETCH_RETURN_EXPENSE_RATIO_START:
      return {
        ...state,
      };  
    case informationConstants.FETCH_RETURN_EXPENSE_RATIO_SUCCESS:
      return {
        ...state,
        statistic: filterReturnExpenseRatio(state.statistic, action.payload)
      };
    case informationConstants.FETCH_RETURN_EXPENSE_RATIO_FAILURE:
      return {
        ...state,
        statistic: resetReturnExpenseRatio(state.statistic),
      };
    case informationConstants.FETCH_MONTHLY_PROFIT_START:
      return {
        ...state,
      };  
    case informationConstants.FETCH_MONTHLY_PROFIT_SUCCESS:
      return {
        ...state,
        statistic: filterMonthlyProfit(state.statistic, action.payload)
      };
    case informationConstants.FETCH_MONTHLY_PROFIT_FAILURE:
      return {
        ...state,
        statistic: resetMonthlyProfit(state.statistic),
      };
    case informationConstants.FETCH_RETURN_HISTORY_START:
      return {
        ...state,
      };  
    case informationConstants.FETCH_RETURN_HISTORY_SUCCESS:
      return {
        ...state,
        statistic: filterReturnHistory(state.statistic, action.payload)
      };
    case informationConstants.FETCH_RETURN_HISTORY_FAILURE:
      return {
        ...state,
        statistic: resetReturnHistory(state.statistic),
      };
    case informationConstants.CHANGE_DRAWDOWN_STATISTIC_FILTERS:
      return {
        ...state,
        statistic: changeDrawdownSortingFilters(state.statistic, action.payload)
      };
    case informationConstants.CHANGE_NAV_GRAPH_DATE:
      return {
        ...state,
        statistic: changeNavGraphDate(state.statistic, action.payload),
      };
    case informationConstants.CHANGE_SORTED_DRAWDOWN:
      return {
        ...state,
        statistic: changeSortedDrawdown(state.statistic, action.payload),
      };
    case informationConstants.FETCH_DIVIDEND_START:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          dividendByDateType: setIsFetching(state.dividend.dividendByDateType)
        }
      };
    case informationConstants.FETCH_DIVIDEND_SUCCESS:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          currentPage: action.payload.currentPage,
          totalPage: action.payload.totalPage,
          dividendByDateType: filterDataResult(state.dividend.dividendByDateType, action.payload.items)
        }
      };
    case informationConstants.FETCH_DIVIDEND_FAILURE:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          currentPage: 1,
          totalPage: 1,
          dividendByDateType: resetDataResult(state.dividend.dividendByDateType, action.payload)
        }
      };
    case informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_START:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          dividendGroupByYear: setIsFetching(state.dividend.dividendGroupByYear)
        }
      };
    case informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_SUCCESS:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          dividendGroupByYear: filterDataResult(state.dividend.dividendGroupByYear, action.payload)
        }
      };
    case informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_FAILURE:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          dividendGroupByYear: resetDataResult(state.dividend.dividendGroupByYear, action.payload)
        }
      };
    case informationConstants.FETCH_DIVIDEND_DESCRIPTION_START:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          descriptions: setIsFetching(state.dividend.descriptions)
        }
      };
    case informationConstants.FETCH_DIVIDEND_DESCRIPTION_SUCCESS:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          descriptions: filterDataResult(state.dividend.descriptions, action.payload)
        }
      };
    case informationConstants.FETCH_DIVIDEND_DESCRIPTION_FAILURE:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          descriptions: resetDataResult(state.dividend.descriptions, action.payload)
        }
      };
    case informationConstants.FETCH_DIVIDEND_CHANGE_PAGE:
      return {
        ...state,
        dividend: {
          ...state.dividend,
          currentPage: action.payload
        }
      };
    default:
      return state;
  }
};

export default informationReducer;
